if (!customElements.get('gp-plant-v2')) customElements.define('gp-plant-v2', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const find = selector => this.querySelector(selector);
    const variants = JSON.parse(find('[data-variants]').textContent);
    const form = find('form[id^="gpv2-form-"]');
    find('.variant-fallback').hidden = true;
    const quantity = find('[name="quantity"]');
    const image = find('#gpv2-main-image');
    const buttons = [...this.querySelectorAll('[data-add]')];
    const mobileBar = find('.mobile-buy');
    const mainBuy = find('.buy-row');
    const optionsDialog = find('#gpv2-options-dialog');
    const imageDialog = find('#gpv2-image-dialog');
    const statuses = [...this.querySelectorAll('.cart-status, .mobile-cart-status')];
    let scrollFrame = 0;
    this.syncMobile = () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        mobileBar.hidden = !(mainBuy.getBoundingClientRect().bottom < 0 && this.getBoundingClientRect().bottom > window.innerHeight);
      });
    };
    window.addEventListener('scroll', this.syncMobile, {passive:true});
    window.addEventListener('resize', this.syncMobile);
    this.mobileObserver = new ResizeObserver(this.syncMobile);
    this.mobileObserver.observe(this);
    let previousOverflow = '';
    optionsDialog?.addEventListener('close', () => {document.body.style.overflow = previousOverflow;this.syncMobile();});
    optionsDialog?.addEventListener('click', event => {
      if (event.target !== optionsDialog) return;
      const rect = optionsDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) optionsDialog?.close();
    });
    let selected = variants.find(v => String(v.id) === form.elements.id.value) || variants[0];
    let busy = false;
    let planterKind = 'none';
    const planterSelections = new Map();
    const planter = () => planterKind === 'none' ? null : planterSelections.get(planterKind);
    const planterReady = () => planterKind === 'none' || Boolean(planter()?.available);
    const unitPrice = () => selected.price + (planter()?.price || 0);
    const money = cents => new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'HKD',minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
    const count = () => Math.max(1,Math.min(99,Math.floor(Number(quantity.value)||1)));
    const galleryThumbs = [...this.querySelectorAll('.thumbnails [data-image]')];
    let galleryIndex = Math.max(0, galleryThumbs.findIndex(t => t.getAttribute('aria-pressed') === 'true'));
    const showImage = (url, alt) => {
      if (!url) return;
      image.removeAttribute('srcset'); image.src = url; image.alt = alt || image.alt;
      const nextIndex = galleryThumbs.findIndex(t => t.dataset.image.split('?')[0] === url.split('?')[0]);
      if (nextIndex >= 0) galleryIndex = nextIndex;
      if (imageDialog.open) {find('#gpv2-large-image').src = url; find('#gpv2-large-image').alt = image.alt;}
      const activeThumb = galleryThumbs[galleryIndex];
      if (activeThumb) {
        const strip = activeThumb.parentElement;
        const delta = activeThumb.getBoundingClientRect().left - strip.getBoundingClientRect().left;
        if (delta < 0 || delta + activeThumb.offsetWidth > strip.clientWidth) strip.scrollLeft += delta;
      }

      this.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', b.dataset.image.split('?')[0] === url.split('?')[0]));
    };
    const moveGallery = direction => {
      if (galleryThumbs.length < 2) return;
      const thumb = galleryThumbs[(galleryIndex + direction + galleryThumbs.length) % galleryThumbs.length];
      showImage(thumb.dataset.image, thumb.dataset.alt);
    };
    const setupGallery = surface => {
      if (!surface || galleryThumbs.length < 2) return;
      surface.classList.add('gpv2-swipe-gallery');
      const chinese = this.dataset.lang?.startsWith('zh');
      for (const direction of [-1, 1]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gpv2-gallery-arrow ' + (direction < 0 ? 'is-prev' : 'is-next');
        button.setAttribute('aria-label', chinese ? (direction < 0 ? '上一張圖片' : '下一張圖片') : (direction < 0 ? 'Previous image' : 'Next image'));
        button.innerHTML = direction < 0 ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 5-7 7 7 7"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 5 7 7-7 7"/></svg>';
        button.addEventListener('click', () => moveGallery(direction));
        surface.append(button);
      }
      let gesture = null;
      surface.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.pointerType === 'mouse' || event.target.closest('button')) return;
        gesture = {id:event.pointerId,x:event.clientX,y:event.clientY};
        surface.setPointerCapture(event.pointerId);
      });
      surface.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        gesture = null;
        if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.3) moveGallery(dx < 0 ? 1 : -1);
      });
      surface.addEventListener('pointercancel', () => {gesture = null;});
      surface.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();moveGallery(event.key === 'ArrowRight' ? 1 : -1);
      });
      surface.querySelectorAll('img').forEach(img => {img.draggable = false;});
    };
    setupGallery(find('.hero-image'));
    setupGallery(imageDialog);
    const update = () => {
      quantity.value = count();
      form.elements.id.value = selected.id;
      this.querySelectorAll('[data-current-size]').forEach(n => {n.textContent = selected.options[0];});
      this.querySelectorAll('[data-happiness-size]').forEach(b => {
        const ids = b.dataset.happinessSize.split(',');
        b.disabled = busy || !variants.some(v => ids.includes(String(v.id)) && v.available);
        b.setAttribute('aria-pressed', ids.includes(String(selected.id)));
      });
      this.querySelectorAll('[data-happiness-panel]').forEach(p => {p.hidden = !p.dataset.happinessPanel.split(',').includes(String(selected.id));});
      if (this.dataset.sizeOptions) this.querySelectorAll('[data-current-size]').forEach(node => {node.textContent = selected.public_title || selected.title;});
      find('#gpv2-price').textContent = money(unitPrice());
      const priceCaption = find('[data-planter-price-caption]');
      if (priceCaption) priceCaption.textContent = planter() ? this.dataset.planterCombinedLabel : this.dataset.planterIncludedLabel;
      const selectedPot = find('#gpv2-selected-pot');
      if (selectedPot) selectedPot.textContent = selected.public_title || selected.title;
      const mobileSelection = find('#gpv2-mobile-pot');
      mobileSelection.textContent = [mobileSelection.dataset.size, mobileSelection.dataset.summaryOnly ? '' : selected.public_title || selected.title, planterKind === 'none' ? '' : [find('[data-planter-kind="' + planterKind + '"]').dataset.planterName, planter()?.title || this.dataset.planterRequiredLabel].join(' · ')].filter(Boolean).join(' · ');
      find('#gpv2-mobile-price').textContent = money(unitPrice() * count());
      const sheetPrice = find('#gpv2-sheet-price');
      if (sheetPrice) sheetPrice.textContent = money(unitPrice() * count());
      buttons.forEach(b => {b.disabled = busy || !selected.available || !planterReady(); b.textContent = busy ? this.dataset.addingLabel : !planterReady() ? this.dataset.planterRequiredLabel : selected.available ? this.dataset.addLabel + ' · ' + money(unitPrice() * count()) : this.dataset.soldLabel;});
      this.querySelectorAll('[data-planter-kind]').forEach(b => {b.disabled = busy; b.setAttribute('aria-pressed', b.dataset.planterKind === planterKind);});
      this.querySelectorAll('[data-planter-detail]').forEach(panel => {panel.hidden = panel.dataset.planterDetail !== planterKind;});
      this.querySelectorAll('[data-planter-size]').forEach(select => {select.disabled = busy; select.value = String(planterSelections.get(select.dataset.planterSize)?.id || '');
        const link = select.parentElement.querySelector('[data-planter-link]');
        link.href = select.dataset.productUrl + (select.value ? '?variant=' + select.value : '');
      });
      find('#gpv2-minus').disabled = count() <= 1;
      find('#gpv2-plus').disabled = count() >= 99;
      this.querySelectorAll('[data-variant]').forEach(b => b.setAttribute('aria-pressed', String(selected.id) === b.dataset.variant));
    };
    this.addEventListener('click', event => {
      const planterButton = event.target.closest('[data-planter-kind]');
      if (planterButton && !busy) {planterKind = planterButton.dataset.planterKind; statuses.forEach(status => status.textContent = ''); update();}
      const sizeButton = event.target.closest('[data-happiness-size]');
      if (sizeButton && !busy) {
        const ids = sizeButton.dataset.happinessSize.split(',');
        const available = variants.filter(v => ids.includes(String(v.id)) && v.available);
        const next = available.find(v => v.options[1] === selected.options[1]) || available[0];
        if (next) {
          selected = next; statuses.forEach(status => status.textContent = ''); update();
          showImage(next.featured_image?.src, next.title);
          const url = new URL(location.href); url.searchParams.set('variant', next.id); history.replaceState({}, '', url);
        }
      }
      const variantButton = event.target.closest('[data-variant]');
      if (variantButton) {
        const next = variants.find(v => String(v.id) === variantButton.dataset.variant);
        if (!next || !next.available || busy) return;
        selected = next; statuses.forEach(status => status.textContent = ''); update();
        showImage(next.featured_image?.src, next.title);
        const url = new URL(location.href); url.searchParams.set('variant', next.id); history.replaceState({}, '', url);
      }
      const thumb = event.target.closest('[data-image]');
      if (thumb) showImage(thumb.dataset.image, thumb.dataset.alt);
      if (event.target.closest('#gpv2-minus')) {quantity.value = count()-1;update();}
      if (event.target.closest('#gpv2-plus')) {quantity.value = count()+1;update();}
      if (event.target.closest('#gpv2-zoom')) {find('#gpv2-large-image').src=image.src;find('#gpv2-large-image').alt=image.alt;imageDialog.showModal();}
      if (event.target.closest('.close-dialog')) imageDialog.close();
      if (optionsDialog && event.target.closest('.mobile-options-trigger')) {
        previousOverflow = document.body.style.overflow;
        optionsDialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      if (event.target.closest('.options-sheet-close, .options-sheet-done')) optionsDialog?.close();
    });
    this.querySelectorAll('[data-planter-size]').forEach(select => select.addEventListener('change', () => {
      if (busy) return;
      const option = select.selectedOptions[0];
      if (select.value && option?.dataset.available === 'true') planterSelections.set(select.dataset.planterSize, {id:Number(select.value),price:Number(option.dataset.price),title:option.dataset.title,available:true});
      else planterSelections.delete(select.dataset.planterSize);
      statuses.forEach(status => status.textContent = ''); update();
    }));
    quantity.addEventListener('change', update);
    const addToCart = async (variantId, itemCount, extraItems = []) => {
      const cart = document.querySelector('hdt-cart-drawer[ref="hdt-cart"]');
      const sectionId = cart?.getAttribute('section-id');
      const body = {items:[{id:variantId,quantity:itemCount}, ...extraItems], sections_url:location.pathname};
      if (sectionId) body.sections = [sectionId];
      const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.errorLabel);
      // Use the theme's native section rendering; cart:refresh has no listener here.
      if (sectionId && result.sections?.[sectionId]) {
        this.dispatchEvent(new CustomEvent('cart:update', {bubbles:true,detail:{
          resource:{}, sourceId:String(variantId), cartData:result,
          actionAfterATC:'open_cart_drawer', source:'product-form-component',
          data:{itemCount,sections:result.sections}
        }}));
      } else {
        document.dispatchEvent(new CustomEvent('cart:reload'));
      }
    };
    this.querySelectorAll('.care-addon-form').forEach(careForm => {
      const select = careForm.querySelector('select[name="id"]');
      const add = careForm.querySelector('button[type="submit"]');
      const status = careForm.querySelector('.care-addon-status');
      const cartLink = careForm.querySelector('.care-addon-cart');
      const addLabel = add.textContent;
      let careBusy = false;
      const available = () => select.selectedOptions[0]?.dataset.available === 'true';
      select.addEventListener('change', () => {
        status.textContent = '';
        add.disabled = careBusy || !available();
        add.textContent = available() ? addLabel : this.dataset.soldLabel;
      });
      careForm.addEventListener('submit', async event => {
        event.preventDefault();
        if (careBusy || !available()) return;
        const variantId = Number(select.value);
        careBusy = true; add.disabled = true; select.disabled = true;
        add.textContent = this.dataset.addingLabel; status.textContent = '';
        try {
          await addToCart(variantId, 1);
          status.textContent = this.dataset.addedLabel;
          cartLink.hidden = false;
        } catch (error) {status.textContent = error.message || this.dataset.errorLabel;}
        finally {careBusy = false; select.disabled = false; add.disabled = !available(); add.textContent = available() ? addLabel : this.dataset.soldLabel;}
      });
    });
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (busy || !selected.available || !planterReady()) return;
      busy = true; update(); statuses.forEach(status => status.textContent = '');
      try {
        await addToCart(selected.id, count(), planter() ? [{id:planter().id,quantity:count()}] : []);
        statuses.forEach(status => status.textContent = this.dataset.addedLabel);
        find('.cart-link').hidden = false;
      } catch(error) {statuses.forEach(status => status.textContent = error.message || this.dataset.errorLabel);}
      finally {busy=false;update();}
    });
    update();
    this.syncMobile();
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.syncMobile);
    window.removeEventListener('resize', this.syncMobile);
    this.mobileObserver?.disconnect();
    this.querySelector('#gpv2-options-dialog')?.close();
  }
});
